import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field, Flex, Button, Divider, Icon } from 'nallian-shared-ui/lib/components';
import { SelectFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import ReadOnlyFieldValueComponent from '../../../../app/components/ReadOnlyFieldValueComponent';

const PrincipalAppFeatureFlex = styled(Flex)`
  &&.ui.form .field,
  && .field,
  &&.field {
    margin-bottom: 0;
  }
`;

const RemoveFlex = styled(Flex)`
  position: relative;
  z-index: 1;
`;

const PrincipalAppRole = ({
  readOnly,
  editMode,
  index,
  field,
  fields,
  submitProcessing,
  handleRemoveFieldClick,
  features,
}) => {
  const { t } = useTranslation();
  // const dispatch = useDispatch();

  const value = useMemo(() => fields.get(index), [fields, index]);
  const isNew = Boolean(value?.isNew);

  const featureOptions = useMemo(() => {
    const allFields = fields.getAll();

    return features.filter(o => {
      const foundField = allFields.find(f => f.feature === o.value);

      return (
        !foundField || (foundField && index === allFields.findIndex(f => f.feature === o.value))
      );
    });
  }, [features, fields, index]);

  const roles = useMemo(() => {
    if (!value?.feature) return [];

    const selectedTags = value?.roles || [];

    return (features?.find(f => f.value === value.feature)?.communityAppFeatureRoles || [])
      // Obsolete roles can no longer be assigned, but a role already selected
      // before it became obsolete must stay visible so it keeps showing its name.
      .filter(
        r =>
          !r.appInstallationFeatureRole?.isObsolete ||
          selectedTags.includes(r.appInstallationFeatureRole?.tag)
      )
      .map(r => ({
        key: r.appInstallationFeatureRole.tag,
        value: r.appInstallationFeatureRole.tag,
        text: r.alias || r.appInstallationFeatureRole.name,
      }));
  }, [features, value]);

  // useEffect(() => {
  // if (isNew) {
  // dispatch(change(ONBOARDING_TEMPLATE_FORM_NAME, `${field}.roles`, []));
  // }
  // }, [isNew, value?.feature, dispatch, field]);

  return (
    <Flex fluid direction="column">
      <PrincipalAppFeatureFlex fluid alignItems="flex-start">
        <Field
          fluid
          label={t('feature')}
          name={`${field}.feature`}
          valueComponent={
            (editMode && !isNew) || readOnly
              ? ReadOnlyFieldValueComponent
              : SelectFieldValueComponent
          }
          options={featureOptions}
          disabled={submitProcessing}
        />
        <Flex margin="0 0.5rem" />
        {!value?.feature ? (
          <Flex margin="2.2rem 0 0" fluid>
            <Flex>
              <Icon name="angle right" />
            </Flex>
            <Flex>{t('firstSelectAFeature')}</Flex>
          </Flex>
        ) : (
          <Field
            fluid
            label={t('roles')}
            name={`${field}.roles`}
            valueComponent={readOnly ? ReadOnlyFieldValueComponent : SelectFieldValueComponent}
            multiple
            options={roles}
            disabled={submitProcessing}
          />
        )}
        {!readOnly && value?.feature && (
          <RemoveFlex direction="column" alignItems="flex-end" margin="2.1rem -2.3rem 0 0.7rem">
            <Button
              linkbutton
              icon="close"
              type="button"
              tabindex="-1"
              i={index}
              onClick={handleRemoveFieldClick}
            />
          </RemoveFlex>
        )}
      </PrincipalAppFeatureFlex>
      {index < fields.length - 1 && <Divider />}
    </Flex>
  );
};

PrincipalAppRole.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  features: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  handleRemoveFieldClick: PropTypes.func.isRequired,
};

export default PrincipalAppRole;
